var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yqg-footer" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "copyright-info" }, [
        _c("div", { staticClass: "company-info" }, [
          _vm._v(
            "\n                ©2019 深圳市世纪融泰融资担保有限公司\n            "
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "copyright",
            attrs: {
              href: "https://beian.miit.gov.cn",
              rel: "noopener noreferrer",
              target: "_blank",
            },
          },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.icpNumber) + "\n            "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact-info" }, [
      _c("span", { staticClass: "tel" }, [
        _vm._v("\n                客服热线：0755-89542206\n            "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "office-tel" }, [
        _vm._v("\n                办公电话：0755-83934505\n            "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "email" }, [
        _vm._v(
          "\n                邮箱地址：support@sjrtguarantee.com\n            "
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "work-time" }, [
        _vm._v("\n                客服工作时间：9:00~18:00\n            "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "workplace" }, [
      _c("span", [
        _vm._v(
          "办公地址：深圳市福田区沙头街道下沙社区滨河路9289号下沙村京基滨河时代广场A座2102"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }